
import Vue from 'vue';
import { Toast,Dialog } from 'vant';
import AES from "@/tools/AES.js";
Vue.use(Toast);Vue.use(Dialog);
import {getParams,getParamsHash} from "@/tools/common";
import {loginAjax, bondoPhoneLoginCheck, bondoEmailLoginCheck } from "@/api/index";
import {LOGIN_RESULT_MAP, mapFields} from "../util/FieldMapUtil";
export const myMixin = {
    data() {
        return {
            token: '',
            currentCountry: '',
            downnum: 60,
            startTimeDown: false,//是否开启倒计时
            timer: null,
            moreLang: {

            },
            // selOneAccount:{
            //     show:false,
            //     accountList:[],
            // }
        }
    },
    created() {
         this.currentCountry =  this.getLang1();
    },
    methods: {
        /**
         * 谷歌登录，如果充值官网的域名是buzz结尾，则需要拼上一个后缀_buzz，登录成功后，跳到另一套域名下
         * 目前主要用于菲律宾info域名被禁情况
         */
        getSuffix() {
          let host = window.location.host
          return host === process.env.buzzcast_host_ph ? '_buzz' : ''
        },
        //去授权
        gosdkAuth(type,u){
          console.log(this.login_redirectURI_guowai);
            Toast.loading({
                duration: 3000, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            let url=""
            if(type==1){
                //url="https://fclogin.xuoj.com/"
                url=this.login_redirectURI_guowai
            }else if(type==2){
                //url="https://fclogin.facecast.xyz/"
                url=this.login_redirectURI_zh
            }
            window.location.replace(url+"loginAuth/"+u+`&t=${Date.now()}`);
        },
        bondoLoginCheckTip(data) {
          let state = data && data.data ? data.data.response : null
          if(state === 0) {
            Toast(this.$t('m.account_no_reg'));
          } else {
            Toast(this.$t('m.account_or_pwd_error'));
          }
        },
        //确认登录
        async confirmLogin(type, json) {

            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                icon: require("../assets/img/loading.gif"),
                className: 'loading'
            });
            /*
            5 缺少参数
            101 sign error
            111 重复登录
            102 登录失败，用户信息不存在
            40007 密码不正确
            10002 用户被删除
            0 登录失败或中国用户不能登录
            40004 临时冻结
            40005 永久冻结
            110 token生成失败

            */
           let newJson= json;
           newJson.type = type;

           try {
             // bondo手机号登录，需要先检验一下手机号是否存在
             if(type === 3) {
               const { data } = await bondoPhoneLoginCheck(newJson);
               console.log('----data----', data)
               if(!(data && data.data && data.data.response === 1)) {
                 this.bondoLoginCheckTip(data)
                 return
               }
             }
             // bondo邮箱登录，需要先检验一下邮箱是否存在
             if(type === 2) {
               const { data } = await bondoEmailLoginCheck(newJson);
               console.log('----data----', data)
               if(!(data && data.data && data.data.response === 1)) {
                 this.bondoLoginCheckTip(data)
                 return
               }
             }

             const { data } = await loginAjax(newJson);
             // Toast.clear();
             if(data.code==202){
               Toast(this.$t('m.reg_success_go_app'));
             }else if (data.code == 1) {
               Toast.clear();
               //Toast('登录成功');
               const loginResult = mapFields(data.data, LOGIN_RESULT_MAP)
               console.log('---phone login----', loginResult)
               localStorage.setItem('userInfo', JSON.stringify(loginResult));
               this.$router.push({
                 name: 'index',
                 params: { userInfo: data.data }
               })
             } else if (data.code == 40007) {
               //账号或密码有误
               Toast(this.$t('m.account_or_pwd_error'));
             } else if (data.code == 40004||data.code == 40005) {
               //冻结
               Toast(this.$t('m.user_frozen'));
             } else if (data.code == 10002) {
               //账号已注销
               Toast(this.$t('m.user_has_delete'));
             } else if (data.code == 102) {
               Toast(this.$t('m.account_no_reg'));
             }
             else  if(data.code === 10403){
               return {
                 loginAgain: true
               }
             }

             else {
               Toast(data.message);
             }

             return {}

           }
           catch (error){
             console.log(error);
           }

        },
        countDown() {
            this.startTimeDown = true;
            this.timer = setInterval(() => {
                this.downnum--
                if (this.downnum <= 0) {
                    clearInterval(this.timer)
                    this.startTimeDown = false;
                    this.downnum = 60;
                }
            }, 1000)
        },
        getLang1(num) {
            let language = navigator.language || navigator.browserLanguage;
            //console.log(language);
            let langDa = language.toUpperCase();
            if (langDa == 'ZH-MO' || langDa == 'ZH-TW' || langDa == 'ZH-HK' || langDa == 'ZH-HANT-TW' || langDa == 'ZH-HANT-HK' || langDa.indexOf("ZH-HANT") != -1) {
                language = 'zh-rHK';
            }
            if (langDa == 'ZH-CN' || langDa == 'ZH-CH' || langDa == 'ZH-AE') {
                language = 'zh';
            }
            if (langDa == 'DE-DE') {
                language = 'de';
            }
            if (langDa == 'AR') {
                //$("html").css("direction", "rtl");
                var box = document.getElementById("app");
                box.style.direction = 'rtl';
            }
            if (num == 2) {
                let lang = language.substr(0, 2);
                return lang;
            } else {
                return language;
            }
        },
        //获取16位随机字符
        createNonceStr() {
            let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

            let nums = "";
            for (let i = 0; i < 16; i++) {//这里是几位就要在这里不改变
                let id = parseInt(Math.random() * 61);
                nums += chars[id];
            }
            return nums;
        },
        //获取设备ID h5随机生成
        randomcode() {
            let randomCode = localStorage.getItem('randomcode');
            if (!randomCode) {
                let a = this.createNonceStr();
                localStorage.setItem('randomcode', a);
                return a
            } else {
                return randomCode
            }
        },
        goDownload() {
            Toast('暂时没有下载链接');
            return false;
            // 唤醒APP
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                window.location.href = "hello://?type=" + type + parameters;//ios app
                window.setTimeout(function () {
                    window.location.href = "http://itunes.apple.com/cn/app/id1544226523";
                }, 3000)
            } else if (navigator.userAgent.match(/android/i)) {
                window.location.href = "hello://com.guochao.zaime?type=" + type + parameters;//android app
                window.setTimeout(function () {
                    window.location.href = "market://details?id=com.guochao.zaime";
                }, 3000)
            } else {
                window.location.href = "https://zaime.gchao.cn";
            }
        },
        getDevice() {
            //获取请求头中的userAgent
            var u = navigator.userAgent;
            //是否是android浏览器
            var isAndroid = u.indexOf('Android') > -1;
            //是否是ios浏览器
            var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isAndroid) {
                return 'android'
            } else if (isIos) {
                return 'ios'
            } else {
                return 'web'
            };
        },
        //解析URL参数
        getParams(name) {
            return getParams(name);
        },
        //解析URL参数
        getParamsHash(name) {
            return getParamsHash(name);
        },
    }
}



// WEBPACK FOOTER //
// ./src/tools/mixins.js